import React from 'react';

import './style.sass';

const CommonSmallText = ({ children, className = '', isOneParagraph = true }) => {
    let noOneParagraph = '';
    if (!isOneParagraph) {
        noOneParagraph = 'common__small-text--more-one-paragraph';
    }

    return <div className={`common__small-text ${className} ${noOneParagraph}`}>{children}</div>;
};

export default CommonSmallText;
